import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "subrow"]

  initialize() {
    this.expanded = false
  }

  connect() {
    this.element.dataset.expanded = this.expanded
  }

  active() {
    return this.element.dataset.expanded === "true"
  }

  toggle(event) {
    if (!event.target.dataset.turboMethod && !event.target.dataset.action) {
      this.expanded = !this.expanded
      this.element.dataset.expanded  = this.expanded
    }
  }

  async toggleSubrow(event) {
    if (this.toggleTarget.href) {
      const frame = this.toggleTarget.getAttribute('data-turbo-frame')
      if (frame) {
        // Wait for the frame navigation to complete before toggling
        await window.Turbo.visit(this.toggleTarget.href, { frame: frame })
      } else {
        // Wait for the full page visit to complete
        await window.Turbo.visit(this.toggleTarget.href)
      }
    }

    setTimeout(() => {
      this.toggle(event);
    }, 100)
  }

  prefetchSubrow(event) {
    // if (this.toggleTarget.href) {
    //   const frame = this.toggleTarget.getAttribute('data-turbo-frame')
    //   console.log('frame', frame)
    //   if (frame) {
    //     // Wait for the frame navigation to complete before toggling
    //     window.Turbo.visit(this.toggleTarget.href, { frame: frame })
    //   } else {
    //     // Wait for the full page visit to complete
    //     window.Turbo.visit(this.toggleTarget.href)
    //   }
    // }
  }
}
